import { isEmpty } from '../../../store/storeFunctions';
import { repiContractFields } from '../../../store/repiStore';
import { string as YupString } from '../../common/Yup';

export function dataCorrectionPaymentHistorySchema(translate) {
    const msgNumber = translate("Repi.Error.Validation.DataCorrection.Number");
    const msgDate = translate("Repi.Error.Validation.DataCorrection.Date");
    const msg984 = translate("Repi.Error.Validation.DataCorrection.Error984");
    const msg991 = translate("Repi.Error.Validation.DataCorrection.Error991");
    const msg993 = translate("Repi.Error.Validation.DataCorrection.Error993");

    // Do not return Yup object().shape()!
    return {
        [repiContractFields.dueDate]: YupString().typeError(msgDate).test("date", msgDate, v => isEmpty(v) || v.toString().match(/^\d{4}-\d{2}-\d{2}/)),
        [repiContractFields.paymentDate]: YupString().typeError(msgDate)
            .test("date", msgDate, v => isEmpty(v) || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
            .test("repi984", msg984, function (v) {
                return !isEmpty(v)
                    || (isEmpty(this.parent[repiContractFields.amountTotal]) || isEmpty(this.parent[repiContractFields.amountOpen]))
                    || (parseFloat(this.parent[repiContractFields.amountOpen]) >= parseFloat(this.parent[repiContractFields.amountTotal]))
            })
            .test("repi993", msg993, function (v) {
                return !(!isEmpty(v) && !isEmpty(this.parent[repiContractFields.amountTotal]) && !isEmpty(this.parent[repiContractFields.amountOpen]) &&
                    parseFloat(this.parent[repiContractFields.amountOpen]) === parseFloat(this.parent[repiContractFields.amountTotal]));
            }),
        [repiContractFields.amountTotal]: YupString()
            .test("number", msgNumber, v => isEmpty(v) || v.toString().match(/^\d+(\.\d+){0,1}$/))
            .test("repi984", msg984, function (v) {
                return !isEmpty(this.parent[repiContractFields.paymentDate])
                    || (isEmpty(v) || isEmpty(this.parent[repiContractFields.amountOpen]))
                    || (parseFloat(this.parent[repiContractFields.amountOpen]) >= parseFloat(v))
            })
            .test("repi991", msg991, function (v) {
                return !(parseInt(this.parent.product) !== 8 && !isEmpty(this.parent[repiContractFields.amountOpen]) && !isEmpty(v) &&
                    parseFloat(this.parent[repiContractFields.amountOpen]) > parseFloat(v));
            })
            .test("repi993", msg993, function (v) {
                return !(!isEmpty(this.parent[repiContractFields.paymentDate]) && !isEmpty(v) && !isEmpty(this.parent[repiContractFields.amountOpen]) &&
                    parseFloat(this.parent[repiContractFields.amountOpen]) === parseFloat(v));
            }),
        [repiContractFields.amountPaid]: YupString().test("number", msgNumber, v => isEmpty(v) || v.toString().match(/^\d+(\.\d+){0,1}$/)),
        [repiContractFields.amountOpen]: YupString()
            .test("number", msgNumber, v => isEmpty(v) || v.toString().match(/^\d+(\.\d+){0,1}$/))
            .test("repi984", msg984, function (v) {
                return !isEmpty(this.parent.paymentDate)
                    || (isEmpty(this.parent[repiContractFields.amountTotal]) || isEmpty(v))
                    || (parseFloat(v) >= parseFloat(this.parent[repiContractFields.amountTotal]))
            })
            .test("repi991", msg991, function (v) {
                return !(parseInt(this.parent.product) !== 8 && !isEmpty(v) && !isEmpty(this.parent[repiContractFields.amountTotal]) &&
                    parseFloat(v) > parseFloat(this.parent[repiContractFields.amountTotal]));
            })
            .test("repi993", msg993, function (v) {
                return !(!isEmpty(this.parent[repiContractFields.paymentDate]) && !isEmpty(this.parent[repiContractFields.amountTotal]) && !isEmpty(v) &&
                    parseFloat(v) === parseFloat(this.parent[repiContractFields.amountTotal]));
            }),
        [repiContractFields.totalAmount]: YupString().test("number", msgNumber, v => isEmpty(v) || v.toString().match(/^\d+(\.\d+){0,1}$/)),
        [repiContractFields.overdueAmount]: YupString().test("number", msgNumber, v => isEmpty(v) || v.toString().match(/^\d+(\.\d+){0,1}$/)),
        [repiContractFields.dataEndDate]: YupString().typeError(msgDate).test("date", msgDate, v => isEmpty(v) || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
    };
}